<template>
  <v-dialog class='exercise-blocker-dialog' :value='showDialog' width='400' persistent>
    <v-card max-width='600' @click.stop>
      <v-card-title class='justify-center'>{{ $t('RunStatusBlocked.options') }}</v-card-title>
      <v-card-text align='center'>
        <p>{{ $t('RunStatusBlocked.optionsText') }}</p>
        <v-btn color='primary' class='my-5' @click='$emit("reloadInfo")'>
          <v-icon>mdi-refresh</v-icon> {{ $t('RunStatusBlocked.optionReload') }}
        </v-btn>
        <br/>
        <v-btn color='primary' class='my-5' @click='$emit("backToOverview")'>
          <v-icon>mdi-keyboard-backspace</v-icon>{{ $t('RunStatusBlocked.optionBack') }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ModalExerciseBlocker',
    components: { },
    props: {
      showDialog: {
        default: () => true
      }
    },
    computed: {},
    watch: {},
    methods: {}
  }
</script>

<style scoped>

</style>
